import React from "react"
import Select from "react-select";
import { useTranslation } from "react-i18next";

const NewRelationGeneric = ({ handleChange, values, errors, placeholderVal, field, moduleText, occupation, comboData }) => {

  const { t } = useTranslation();

  const hasError = Boolean(errors?.[field]);
  const customTheme = (theme) => ({
    ...theme,
    borderRadius: 0,
    
    colors: {
      ...theme.colors,
      primary25: "lightblue", 
      primary: hasError ? "#dc3545" : "green", 
      
    },
  });
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: hasError ? "#dc3545" : provided.borderColor,
      boxShadow: hasError ? "0 0 0 1px #dc3545" : provided.boxShadow
    })
  };

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}</label>
      <div className="control">
        <Select
          theme={customTheme}
          styles={customStyles}
          
          myFontSize="14px"

          onChange={(event) => handleChange(event, field)}
          
          className={`basic-single form-control txt-view ${hasError ? "border border-danger" : ""}`}
          classNamePrefix="select"
          name={field}
          inputId={field}

          value={field ? values[field] : "" }
          options={comboData}
          getOptionLabel={(option) => `${option.description}`}
          getOptionValue={(option) => `${option}`}
          isClearable={true}
          isSearchable={true}
          placeholder={placeholderVal ? t("combo.placeholder") : null}
        />
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewRelationGeneric;